"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tappedConsign = void 0;

var _Schema = require("../../Schema");

/**
 * A user taps a CTA to consign on iOS
 *
 * subject is the text of the tapped button
 *
 * @example
 * ```
 * tappedConsign({
 *   contextModule: ContextModule.sellHeader,
 *   contextScreenOwnerType: OwnerType.sell,
 *   subject: "Start selling"
 * })
 * ```
 */
const tappedConsign = ({
  contextModule,
  contextScreenOwnerType,
  subject
}) => {
  return {
    action: _Schema.ActionType.tappedConsign,
    context_module: contextModule,
    context_screen_owner_type: contextScreenOwnerType,
    destination_screen_owner_type: _Schema.OwnerType.consignmentSubmission,
    subject
  };
};

exports.tappedConsign = tappedConsign;